import 'dayjs/locale/uk'
import { Dayjs } from 'dayjs'

const uk = {
  calendar: {
    sameDay: function (now: Dayjs) {
      return now.format('[Сьогодні о' + (now.hour() === 11 ? '6' : '') + '] LT')
    },
    nextDay: function (now: Dayjs) {
      return now.format('[Завтра о' + (now.hour() === 11 ? '6' : '') + '] LT')
    },
    lastDay: function (now: Dayjs) {
      return now.format('[Вчора о' + (now.hour() === 11 ? '6' : '') + '] LT')
    },
    nextWeek: function (now: Dayjs) {
      return now.format('[У] dddd [о' + (now.hour() === 11 ? '6' : '') + '] LT')
    },
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
        case 3:
        case 5:
        case 6:
          return now.format('[Минулої] dddd [о' + (now.hour() === 11 ? '6' : '') + '] LT')
        case 1:
        case 2:
        case 4:
          return now.format('[Минулого] dddd [о' + (now.hour() === 11 ? '6' : '') + '] LT')
      }
    },
    sameElse: 'L'
  }
}

export default uk
